export enum LogoWallTextAlignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}
